module.exports = __webpack_public_path__ + "static/media/tam.42781598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sections/Section-Stories/assets/tam.jpg
// module id = 243
// module chunks = 0